import api from ".";

export const getVehiclesPositions = async () => {
  const response = await api.get("v1/fleets/vehicles/rio/positions");
  return response.data;
};

export const getUsersFleetRio = async () => {
  const response = await api.get("v1/fleets/users/rio/all");
  return response.data;
};

export const getUsersFleet = async () => {
  const response = await api.get('v1/fleets/users/rio/members');
  return response.data;
}


